import { useEffect, useRef } from 'react';

function ErrorMessage(props) {
	const ref = useRef(null);

	useEffect(() => {
		if (ref.current) {
			const rect = ref.current.getBoundingClientRect();
			const absoluteTop = window.pageYOffset + rect.top;
			window.scrollTo({ top: Math.max(absoluteTop - 150, 0), behavior: 'smooth' });
		}
	}, [props.text]);

	return (
		<p ref={ref} className="error">{props.text}</p>
	)
}

export default ErrorMessage;